
namespace Matrix.DataAudit {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.responsive()
    @Serenity.Decorators.panel()
    export class AccountHistoryDialog extends SiteEntityDialog<AccountHistoryRow, any> {
        protected getFormKey() { return AccountHistoryForm.formKey; }
        protected getIdProperty() { return AccountHistoryRow.idProperty; }
        protected getLocalTextPrefix() { return AccountHistoryRow.localTextPrefix; }
        protected getNameProperty() { return AccountHistoryRow.nameProperty; }
        protected getService() { return AccountHistoryService.baseUrl; }

        protected form = new AccountHistoryForm(this.idPrefix);

        protected updateInterface() {
            super.updateInterface();

            this.toolbar.element.hide();
            this.cloneButton.hide();
        }

        protected get hasPendingChanges() {
            return false;
        }
    }
}